import type { PlanTier } from '@/api-types';

/**
 * Canonical display order for plan tiers.
 * Imported by both the full pricing page and the landing-page pricing teaser
 * so the two cannot drift visually.
 */
export const PLAN_ORDER: readonly PlanTier[] = ['free', 'pro', 'team', 'enterprise'];
